import { render, staticRenderFns } from "./BusinessWonership.vue?vue&type=template&id=5e20ceb0&"
import script from "./BusinessWonership.vue?vue&type=script&lang=js&"
export * from "./BusinessWonership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports